<template>
    <div class="modal bd-example-modal-lg fade show" tabindex="-1" role="dialog" aria-hidden="true" style="display: block; opacity: 1">
        <div class="modal-dialog modal-dialog-centered modal-queue-details" role="document">
            <div class="modal-content" v-if="tableData.length > 0">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        Job: {{tableData[0].class_name}}
                        queue: {{tableData[0].queue}}
                    </h5>
                    <button type="button" class="close" aria-label="Close" @click="onClose">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="job-errors">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th>Error</th>
                                <th>Started at</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in tableData">
                                <td :title="item.error">{{ archiveText(item.error) }}</td>
                                <td>{{ formatDate(item.start_time) }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-sm" @click="onClose">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import modalMixin from '../../common/modal-mixin';
    import moment from 'moment';
    export default {
        name: 'jobErrors',
        props :{
            jobClass: {
                type: String,
                required: true,
            }
        },
        mixins: [modalMixin],
        data(){
            return {
                tableData: [],
            }
        },
        methods: {
            getErrors() {
                let params = {
                    payload: {
                        className : this.jobClass,
                    }
                }
                this.$statsService.getErrorsByName(params).then( (data) => {
                    this.tableData = data.body;
                });
            },
            archiveText(text) {
                let limit = 50
                return text.length > limit + 3 ? text.substring(0, limit) + '...' : text;
            },
            formatDate(time) {
                return moment(time).format('YYYY-MM-DD HH:mm');
            },
        },
        mounted() {
            this.getErrors();
        },
    }
</script>
<style lang="scss" scoped>
    .job-errors {
        padding: 15px;
        .table {
            th {
                font-size: 13px;
            }
            td {
                font-size: 12px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/stats/tables/JobErrorsPopUp.vue